var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateOrganization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CreateOrganization_svg__clip0_801_3010)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CreateOrganization_svg__clip1_801_3010)",
    stroke: "#3a3a3a",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.333a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666zM1.667 10h16.666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1.667A12.75 12.75 0 0113.333 10 12.75 12.75 0 0110 18.333 12.75 12.75 0 016.667 10 12.75 12.75 0 0110 1.667z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CreateOrganization_svg__clip0_801_3010"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 10 10)",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "CreateOrganization_svg__clip1_801_3010"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgCreateOrganization;